import { useCasaviContactWhitelistSearchQuery } from "@/common/api/casavi/contact-whitelist/use-casavi-contact-whitelist-search.query";
import { MetricCard } from "@/components/dashboard/cards/metric-card";
import { ListChecksIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ContactWhitelistMetric() {
  const { t } = useTranslation(["casavi", "common"]);
  const { data, isLoading } = useCasaviContactWhitelistSearchQuery({
    options: {
      body: {},
      parameters: { page: 1, pageSize: 1 },
    },
  });

  return (
    <MetricCard
      icon={ListChecksIcon}
      label={t("casavi:ContactWhitelist")}
      value={data?.meta?.total ?? 0}
      loading={isLoading}
    />
  );
}
